import { ROLES } from './constants';

export default (user) => (
  user.is_stroymanager ? ROLES.stroymanager
    : user.is_constructor ? ROLES.constructor
      : user.is_client ? ROLES.client
        : user.is_admin ? ROLES.admin
          : user.is_chief ? ROLES.chief
            : '');
